<div>
  <div
    tabindex="-1"
    *ngIf="
      content?.errorCode || content?.loginFormAttributes?.formAlertSuccessIcon
    "
    class="form-alert"
    [ngClass]="{ mfaSuccess: content.pageContent.mfaSuccess }"
    id="formAlertId"
  >
    <idp-form-alert
      [message]="content?.errorMessage"
      [showCloseButton]="true"
      [successIcon]="content?.loginFormAttributes?.formAlertSuccessIcon"
      (closePopup)="onClosePop()"
    ></idp-form-alert>
  </div>

  <idp-login-header
    [ngClass]="
      content?.loginFormAttributes?.errorAlertBanner &&
      content?.loginFormAttributes?.submitAttempt
        ? 'login-header-margin'
        : ''
    "
    [loginHeaderContent]="content?.pageContent?.pageHeader"
    [checkOutWarmState]="checkOutWarmState"
  ></idp-login-header>
  <section
    *ngIf="
      content?.loginFormAttributes?.submitAttempt &&
      content?.loginFormAttributes?.errorAlertBanner
    "
  >
    <idp-alert-warning
      #alertWarning
      (firstInvalidFieldFocusEvent)="firstInvalidFieldFocusEvent()"
      *ngIf="content.loginFormAttributes.errorCount"
      [cntError]="content.loginFormAttributes.errorCount"
      [errorMessage]="content?.pageContent?.errors?.alertWarning"
    ></idp-alert-warning>
  </section>
  <ng-container *ngIf="content.formGroup">
    <form [formGroup]="content.formGroup" (ngSubmit)="submit()">
      <div id="login-content-body" class="login-content-body">
        <div class="form-group">
          <idp-input
            [ngClass]="{ 'form-group-userId-warm-state': checkOutWarmState }"
            [labelTxt]="content.pageContent?.userIdLabel"
            formControlName="userId"
            id="userId"
            (value)="onChange()"
            (focusOut)="onFocussedOut('userId')"
          ></idp-input>

          <div *ngIf="showErrorMessageuserId" class="error__message--userId">
            <span
              class="errorMessageText"
              [innerHTML]="content?.pageContent?.errors?.usernameErrorMessage"
            ></span>
          </div>
        </div>
        <!--Start Display Last Name Input if Username is enter -->
        <div
          *ngIf="content?.loginFormAttributes?.isLastNameRequired"
          class="form-group"
        >
          <idp-input
            [labelTxt]="content.pageContent?.lastNameLabel"
            formControlName="lastName"
            id="lastName"
            (value)="onChange()"
            (focusOut)="onFocussedOut('lastName')"
          ></idp-input>
          <div
            *ngIf="showErrorMessageLastName"
            class="error__message--lastName"
          >
            <span
              class="errorMessageText"
              [innerHTML]="content?.pageContent?.errors?.lastNameErrorMessage"
            ></span>
          </div>
        </div>
        <!--End Display Last Name Input if Username is enter -->
        <div class="form-group password-input">
          <idp-input
            class=""
            [labelTxt]="content.pageContent?.passwordLabel"
            [trimInput]="true"
            [type]="'password'"
            [eyeIcon]="true"
            (value)="onChange()"
            (focusOut)="onFocussedOut('password')"
            id="password"
            formControlName="password"
          ></idp-input>
        </div>

        <div *ngIf="showErrorMessagePassword" class="error__message--password">
          <span
            class="errorMessageText"
            [innerHTML]="content?.pageContent?.errors?.passwordErrorMessage"
          ></span>
        </div>

        <div
          *ngIf="content.pageContent?.keepMeLoggedInLabel"
          class="login-content-body__check-help-box d-flex"
        >
          <idp-checkbox-standard
            [checked]="form.get('keepMeLoggedIn').value?.value"
            [labelTitle]="content.pageContent?.keepMeLoggedInLabel"
            formControlName="keepMeLoggedIn"
            [id]="'keepMeLoggedIn'"
          ></idp-checkbox-standard>
          <div class="login-help-icon">
            <idp-help-icon
              [helpIcon]="true"
              [tooltip]="true"
              [tooltipContent]="content.pageContent.keepMeLoggedInToolTipMsg"
              [closeOnBackgroundClick]="true"
              [modalTemplate]="true"
              [closeButtonLabel]="'OK'"
              [showCloseIconToolTip]="false"
              [closeEscInfoToolTip]="true"
              [tabIndex]="'-1'"
            ></idp-help-icon>
          </div>
        </div>

        <div class="login-button">
          <idp-button
            [label]="content?.pageContent?.nextDisplayView.button_modal"
            [size]="'full-width'"
            [elementType]="'submit'"
            [disabled]="content?.disableButton"
            [customClass]="'loginModal-button'"
          ></idp-button>
        </div>
      </div>
    </form>
  </ng-container>

  <idp-login-footer
    [loginFooterData]="content?.pageContent?.footer"
    [toggleModalCallback]="toggleModalCallback"
    [checkOutWarmState]="checkOutWarmState"
    [recognitionMode]="recognitionPage"
    (nextDisplayView)="onFooterLinkClick($event)"
    (logOut)="logOut.emit()"
  ></idp-login-footer>
</div>
